import { useContext, useState } from 'react';
import Select from 'react-select';
import Spinner from '../../../reusable/spinner/spinner.component';
import { ToastContext } from '../../../../contexts/toast.context';
import Client from '../../../../tools/client';

import {
  AddShippingButton,
  AddShippingContainer,
  AddShippingInput,
  AddShippingSubtitle,
  ContentContainer
} from './add-shipping-option.styles';

const client = new Client();

const AddShippingOption = ({ providers = [], types = [] }) => {
  const [label, setLabel] = useState('');
  const [price, setPrice] = useState(0);
  const [providerId, setProviderId] = useState(null);
  const [typeId, setTypeId] = useState(null);
  const [freeShippingMinimum, setFreeShippingMinimum] = useState('');
  const [loading, setLoading] = useState(false);

  const { errorToast, successToast } = useContext(ToastContext);

  const addShippingOption = async () => {
    if (!label || price === '') {
      errorToast('Label and Price are required.');
      return;
    }

    setLoading(true);

    const res = await client.createShippingOption({
      label,
      price: parseInt(price, 10),
      providerId: providerId?.value || null,
      typeId: typeId?.value || null,
      freeShippingMinimum: freeShippingMinimum ? parseInt(freeShippingMinimum, 10) : null
    });

    if (res.status === 400 || res.error) {
      setLoading(false);
      errorToast(res.message || 'Failed to create shipping option');
      return;
    }

    successToast('Shipping option created');
    window.location.reload();
  };

  const providerOptions = providers.map(p => ({ value: p.id, label: p.name }));
  const typeOptions = types.map(t => ({ value: t.id, label: t.name }));

  return (
    <AddShippingContainer>
      {loading ? (
        <Spinner />
      ) : (
        <ContentContainer>
          <AddShippingInput
            type="text"
            name="label"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            placeholder="Label"
          />
          <AddShippingInput
            type="number"
            name="price"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            placeholder="Price (in cents)"
          />

          <AddShippingSubtitle>Provider:</AddShippingSubtitle>
          <Select
            options={providerOptions}
            onChange={(option) => setProviderId(option)}
            placeholder="Select provider..."
            isClearable
          />

          <AddShippingSubtitle>Type:</AddShippingSubtitle>
          <Select
            options={typeOptions}
            onChange={(option) => setTypeId(option)}
            placeholder="Select type..."
            isClearable
          />

          <AddShippingInput
            type="number"
            name="freeShippingMinimum"
            value={freeShippingMinimum}
            onChange={(e) => setFreeShippingMinimum(e.target.value)}
            placeholder="Free shipping minimum (optional)"
          />

          <AddShippingButton onClick={addShippingOption}>Add Shipping Option</AddShippingButton>
        </ContentContainer>
      )}
    </AddShippingContainer>
  );
};

export default AddShippingOption;